import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

export default function VimeoLink({ videoId, onChange }) {
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        if (inputValue === '' && !!videoId) {
            setInputValue(`https://vimeo.com/${videoId}`);
        }
    }, [videoId, inputValue]);

    const handleChange = (e) => {
        const newInputValue = e.target.value;
        setInputValue(newInputValue);
        const newVideoId = extractVideoId(newInputValue);
        if (newVideoId !== videoId) {
            onChange(newVideoId);
        }
    }

    return (
        <TextField
            label="URL de la vidéo Vimeo"
            name="vimeo_url"
            type="url"
            size="small"
            value={inputValue}
            onChange={handleChange}
        />
    );
}

function extractVideoId(str) {
  const match = str.match(/\b\d{6,12}\b/);
  return match ? match[0] : null;
}